import React from 'react'

const renderUpdateLink = (item, adjustTickets, showLink = true) => {
  return (
    <React.Fragment>
      <span
        data-testid={showLink ? 'standalone-update' : ''}
        className="text-link"
        onClick={adjustTickets(item.occursAt, item.nativeEventId)}
      >
        Please click here to update.
      </span>{' '}
    </React.Fragment>
  )
}

function UpdateCard({ item, adjustTickets, showLink, dependencies }) {
  return (
    <div className="pt-20">
      <p className="mb-0 text-16 text-light">
        There is membership pricing available for this event.{' '}
        {showLink && renderUpdateLink(item, adjustTickets)}
        {!showLink &&
          dependencies &&
          dependencies.length > 0 &&
          renderUpdateLink(dependencies[0], adjustTickets, showLink)}
      </p>
    </div>
  )
}

export default UpdateCard
